
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component } from '@angular/core';

import { MenuPackage, ContextMenuService } from '@ctrl/ngx-rightclick';
import { MenuComponent } from '@ctrl/ngx-rightclick';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'simple-menu',
  template: `
  <div class="dropdown-menu show" >
    <button class="dropdown-item" (click)="handleClick('1')"><i class="fa fa-edit m-1"></i>{{ edit }}</button>
    <button class="dropdown-item" (click)="handleClick('-1')"> <i class="fa fa-remove m-1"></i>{{ delete }}</button>
  </div>
  `
})
export class SimpleMenuComponent extends MenuComponent {
  edit:string;
  delete:string;
  lazy = false;
  constructor(
    private languageService:LanguageService,
    public menuPackage: MenuPackage,
    public contextMenuService: ContextMenuService,
  ) {
    
    super(menuPackage, contextMenuService);
    this.edit = languageService.translate('edit');
    this.delete = languageService.translate('delete');
  }

  handleClick(msg:string) {
    // tell the menu to close
    this.contextMenuService.closeAll(msg);
    // this.contextMenuService.
  }
}
